import React from 'react';
import { Chat } from '../types/chat';
import ChatListItem from './ChatListItem';

interface ChatListProps {
  chats: Chat[];
  activeChat: Chat | null;
  selectChat: (chatId: string) => void;
  isVisible: boolean;
  onClose: () => void;
}

const ChatList: React.FC<ChatListProps> = ({ 
  chats, 
  activeChat, 
  selectChat,
  isVisible,
  onClose
}) => {
  return (
    <div className={`chat-list ${isVisible ? 'visible' : ''}`}>
      <div className="chat-list-header">
        <h3>Чаты</h3>
        <div className="chat-list-actions">
          <button onClick={onClose} className="close-button" aria-label="Закрыть">×</button>
        </div>
      </div>
      <div className="chat-items">
        {chats.length > 0 ? (
          chats.map(chat => (
            <ChatListItem 
              key={chat.id} 
              chat={chat} 
              isActive={activeChat?.id === chat.id}
              onClick={() => {
                selectChat(chat.id);
                if (window.innerWidth < 768) {
                  onClose();
                }
              }}
            />
          ))
        ) : (
          <div className="no-chats">
            <p>Нет сохраненных чатов</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatList; 